import {ComponentType, ReactNode} from 'react';

type ProviderProps = {
  children: ReactNode;
};

export type ProviderComponent = ComponentType<ProviderProps>;

const composeProviders = (...providers: ProviderComponent[]) => {
  return function ComposedProvider({children}: {children: ReactNode}) {
    return providers.reduceRight((acc, Provider) => {
      return <Provider>{acc}</Provider>;
    }, children);
  };
};

export default composeProviders;
